import { useState } from 'react';
import { Plus } from 'lucide-react';

export default function CreateRoomForm({ onCreate, loading }) {
  const [roomName, setRoomName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!roomName.trim() || loading) return;
    onCreate(roomName.trim());
  };

  return (
    <form onSubmit={handleSubmit}>
      <label className="block text-sm font-medium text-charcoal mb-2">Room name</label>
      <input
        type="text"
        value={roomName}
        onChange={(e) => setRoomName(e.target.value)}
        placeholder="Friday Art Sesh"
        maxLength={40}
        className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-canvas text-charcoal placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-amber/50 focus:border-amber font-display"
      />
      <button
        type="submit"
        disabled={!roomName.trim() || loading}
        className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-amber text-white font-medium font-display hover:bg-amber-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Plus className="w-5 h-5" />
        {loading ? 'Creating...' : 'Create Room'}
      </button>
    </form>
  );
}
